// extracted by mini-css-extract-plugin
export default {"summary":"TasksProjectIssuesPage_summary__KXEBz","title":"TasksProjectIssuesPage_title__x9gQn"};